import { dateSerializer } from 'domain/entity/common/utils';
import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class ReportPreviewContext {
    constructor(
        @JsonProperty({ required: true }) readonly userId: string,
        @JsonProperty({ required: true }) readonly language: string,
        @JsonProperty({ required: true }) readonly languageName: string,
        @JsonProperty({ required: true }) readonly locationId: string,
        @JsonProperty({ required: true }) readonly locationName: string,
        @JsonProperty({ required: true }) readonly locationTags: string,
        @JsonProperty({ required: true, beforeDeserialize: dateSerializer }) readonly periodFrom: Date,
        @JsonProperty({ required: true, beforeDeserialize: dateSerializer }) readonly periodTo: Date,
        @JsonProperty({ required: true }) readonly deploymentId: string
    ) {}
}

@JsonObject()
export class ReportSimulation {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true }) readonly name: string,
        @JsonProperty({ required: true }) readonly templateDashboardId: string,
        @JsonProperty({ required: true, type: ReportPreviewContext }) readonly context: ReportPreviewContext,
        @JsonProperty({ required: true}) readonly publishDate: string
    ) {}
}
